<template>
  <div>
    <!-- List payment late -->
    <div class="box box-success">
      <div>
        <div class="box-header">
          <h3 class="box-title">
            {{ $t("StatisticalService.title_payment_late") }}
          </h3>
        </div>
        <div class="box-body">
          <div class="col-md-12" style="max-height: 150px;overflow-y:auto;">
            <b-table
              selectable
              sticky-header
              @row-selected="myRowClickHandler"
              :select-mode="'single'"
              responsive
              head-variant="light"
              :items="columnDataPaymentLate"
              :fields="column_fields_payment_late"
              class="mt-3"
              outlined
            >
              <template #head()="scope">
                <div>{{ $t(scope.label) }}</div>
              </template>
            </b-table>
          </div>
        </div>
      </div>
    </div>
    <!-- List case -->
    <div class="box box-success">
      <div>
        <div class="box-header">
          <h3 class="box-title">
            {{ $t("StatisticalService.title_repair_list") }}
          </h3>
        </div>
        <div class="box-body" style="text-align:center">
          <div class="col-md-12" style="max-height: 150px;overflow-y:auto;">
            <b-table
              selectable
              class="my-table-scroll"
              @row-selected="myRowClickFeedBack"
              :select-mode="'single'"
              responsive
              :items="columnDataRepairList"
              :fields="column_fields_repair_list"
              outlined
            >
              <template #head()="scope">
                <div>{{ $t(scope.label) }}</div>
              </template>
            </b-table>
          </div>
          <div>
            <span @click="onViewAllCases()" style="color:blue;cursor: pointer"
              >View all cases</span
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import utils from "@/lib/utils";

export default {
  name: "StatisticalService",
  data() {
    return {
      columnDataPaymentLate: [],
      column_fields_payment_late: [
        {
          key: "apartment",
          label: "invoice_general_invoice.apartment_code",
          class: "text-center"
        },
        {
          key: "date_issued",
          label: "invoice_general_invoice.notify_date",
          class: "text-center"
        },
        {
          key: "total_fees",
          label: "service_history.total_fees",
          class: "text-center"
        },
        {
          key: "service_name",
          label: "service.service_type",
          class: "text-center"
        }
      ],
      columnDataRepairList: [],
      column_fields_repair_list: [
        { key: "case_code", label: "case.code", class: "text-center" },
        { key: "assign_to", label: "case.assignto", class: "text-center" },
        { key: "date_issued", label: "case.opendate", class: "text-center" },
        { key: "priority", label: "case.priority", class: "text-center" }
      ]
    };
  },
  watch: {
    GET_REPAIR_LIST_DATA: function() {
      this.columnDataRepairList = [];
      let data = this.GET_REPAIR_LIST_DATA.data;
      for (let i = 0, size = data.length; i < size; i++) {
        let priority = "";
        if (data[i].priority == 1) {
          priority = "Quan trọng";
        } else if (data[i].priority == 2) {
          priority = "Cao";
        } else if (data[i].priority == 3) {
          priority = "Trung bình";
        } else if (data[i].priority == 4) {
          priority = "Thấp";
        } else {
          priority = "Unknow";
        }
        let filter = {
          case_id: data[i].case_id,
          case_code: data[i].case_code,
          assign_to: data[i].assign_to ? data[i].assign_to : "Unknown",
          date_issued: utils.formatSqlDate(data[i].date_issued, "YYYY-MM-DD HH:mm:ss", "DD/MM/YYYY"),
          priority: priority
        };
        this.columnDataRepairList.push(filter);
      }
    }
  },
  computed: {
    ...mapGetters([
      "GET_REPAIR_LIST_DATA"
    ])
  },
  methods: {
    ...mapActions([
      "GET_LIST_DEBT_PAYMENT",
      "GET_REPAIR_LIST"
    ]),
    myRowClickFeedBack: function(item) {
      let self = this;
      self.$router.push({
        name: "CaseAdd",
        params: {
          id: item[0].case_id
        }
      });
    },
    myRowClickHandler: function(item) {
      let self = this;
      self.$router.push({
        name: "InvoiceAdd",
        params: {
          id: item[0].invoice_id
        }
      });
    },
    onViewAllCases: function() {
      let filter = {
        isGetAll: "True"
      };
      this.GET_REPAIR_LIST(filter);
    }
  },
  components: {},
  mounted() {
    this.GET_LIST_DEBT_PAYMENT().then(
      function(res) {
        let data = res.data;
        for (let i = 0, size = data.length; i < size; i++) {
          let filter = {
            id: 0,
            apartment: data[i].apartment,
            date_issued: utils.formatSqlDate(data[i].date_issued, "YYYY-MM-DD HH:mm:ss", "DD/MM/YYYY"),
            total_fees: utils.convertFormatNumberToMoney(data[i].total_fees),
            service_name: data[i].service_name,
            invoice_id: data[i].invoice_id
          };
          this.columnDataPaymentLate.push(filter);
        }
      }.bind(this)
    );
    let data = {
      isGetAll: "False"
    };
    this.GET_REPAIR_LIST(data);
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>



// WEBPACK FOOTER //
// src/views/DashBoard/StatisticalService.vue